import React from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import NavigationBar from "./Components/NavigationBar.tsx";
import HeartyEarth from "./Pages/HeartyEarth.tsx";
import BlogPost from "./Components/Contentful/BlogPost.tsx";
import ContentContainer from "./Components/ContentContainer.tsx";
import facebookIcon from "./assets/facebook.svg";
import BlogIndex from "./Components/Contentful/BlogIndex.tsx";

function App() {
  return (
    <>
      <NavigationBar />
      <div className="app">
        <Routes>
          <Route path="/" element={<HeartyEarth />} />
          <Route path="/post/:slug" element={<BlogPost />} />
          <Route
            path="/news"
            element={<BlogIndex />}
          />
        </Routes>
      </div>
      <ContentContainer
        footer={true}
        children={
          <>
            <div className="row">
              <div className="col-auto">
                <h1>Discover more!</h1>
              </div>
            </div>
            <div className="row">
              <hr />
            </div>

            <div className="row" style={{ justifyContent: "space-between", rowGap: "2rem"}}>
                <div className="col">
                  <div className="row">
                    <div className="col-auto">
                      <button
                        className="secondary"
                        onClick={() =>
                          window.open(
                            "https://www.facebook.com/OxfordCityLarder?locale=en_GB",
                            "_blank"
                          )
                        }
                      >
                        HeartyEarth
                        <img
                          src={facebookIcon}
                          alt="facebook-icon"
                          className="icon md-32 outlined"
                        />
                      </button>
                    </div>
                  </div>
              </div>

              <div className="col-6">
                <div className="row">
                  <h3>Contact us!</h3>
                </div>
                <br />
                <div className="row">
                  <span>Mobile:</span>
                  <span>(+44) 07887 902412</span>
                </div>
                <br />
                <div className="row">
                  <span>Email:</span>
                  <span>HeartyEarthOxford@gmail.com</span>
                </div>
              </div>
            </div>
          </>
        }
      />
    </>
  );
}

export default App;
